import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import ProductLabel from '@/components/molecules/productLabel'
import { FC } from 'react'
import { ImageLabel, TextLabel } from '@/network/graphql.g'
import ProductBadge from '@/components/molecules/productBadge'

type ProductLabelsProps = {
  badges: ImageLabel[]
  labels: TextLabel[]
  labelStyle: ProductLabelStyle
} & Rest

export enum ProductLabelStyle {
  Listing,
  Detail
}

const ProductLabels: FC<ProductLabelsProps> = ({
  badges,
  labels,
  labelStyle,
  ...rest
}) => {
  return (
    <StyledLabelsWrapper {...rest}>
      {labels?.map((label, offset) => (
        <ProductLabel
          isDetail={labelStyle === ProductLabelStyle.Detail}
          key={`label-${offset}`}
          label={label}
        />
      ))}
      {badges?.map((badge, offset) => (
        <ProductBadge
          key={`badge-${offset}`}
          badge={badge}
          labelStyle={labelStyle}
          isDetail={labelStyle === ProductLabelStyle.Detail}
        />
      ))}
    </StyledLabelsWrapper>
  )
}

export default ProductLabels

const StyledLabelsWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: start;
  position: absolute;
  left: 0px;
`
